import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert,
  AlertTitle,
  CircularProgress,
  Typography
} from '@mui/material';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  loading = false,
  error = null,
  success = false,
  successMessage = 'Action completed successfully!',
  confirmText = 'Yes',
  cancelText = 'No'
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      PaperProps={{
        sx: { minWidth: '400px' }
      }}
    >
      <DialogTitle id="confirmation-dialog-title">
        {/* Logic: If success show 'Success', else if error show 'Error', else original title */}
        {success ? 'Success' : (error ? 'Error' : title)}
      </DialogTitle>

      <DialogContent>
        {/* Success State */}
        {success && (
          <Alert severity="success" sx={{ width: '100%' }}>
            <AlertTitle>Success</AlertTitle>
            {successMessage}
          </Alert>
        )}

        {/* Error State */}
        {error && (
          <Alert severity="error" sx={{ width: '100%' }}>
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        )}

        {/* Default State (Initial Question) */}
        {!success && !error && !loading && (
          <DialogContentText id="confirmation-dialog-description">
            {content}
          </DialogContentText>
      )}

      {loading && (
         <Typography sx={{ textAlign: 'center', py: 2 }}>
            Please wait... <CircularProgress size={20} sx={{ ml: 1 }} />
         </Typography>
      )}
      </DialogContent>

      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        
        {/* 
          LOGIC EXPLANATION:
          1. If 'success' is TRUE or 'error' exists: Show ONLY the 'Close' button.
          2. Else (Default): Show 'Yes' and 'No' buttons.
          3. If 'loading': Hide all buttons.
        */}

        {/* Case 1: Success or Error -> Show Only Close Button */}
        {(success || error) && !loading && (
          <Button 
            onClick={onClose} 
            variant="contained" 
            color={success ? "success" : "primary"}
            sx={{ minWidth: '100px' }}
          >
            Close
          </Button>
        )}

        {/* Case 2: Default (No message yet) -> Show Yes/No Buttons */}
        {!success && !error && !loading && (
          <>
            <Button 
              onClick={onClose} 
              color="primary"
            >
              {cancelText}
            </Button>
            <Button 
              onClick={onConfirm} 
              color="primary" 
              variant="contained"
              autoFocus
            >
              {confirmText}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;